import script from "./MyMGMPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyMGMPage.vue?vue&type=script&setup=true&lang=ts"

import "./MyMGMPage.vue?vue&type=style&index=0&id=3bc046ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bc046ce"]])

export default __exports__